module.exports = __webpack_public_path__ + "img/梅花中级大师@2x.85bc7545.png";